// REACT
import * as React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR COMPONENTS
import FlatButton from 'material-ui/FlatButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';

// CUSTOM COMPONENTS
import { FluidSection } from 'components/FluidSection/FluidSection';
import { Calendar } from 'components/Calendar/Calendar';
import { Content } from 'components/Content/index';
import { List } from 'components/List';
import { ModuleList } from 'components/ModuleList';
import { Button } from 'components/Button';
import { LogoAvatar, StretchCard } from 'components';
import ConfirmGetMaple from 'components/Dialog/ConfirmGetMaple';

// CONSTANTS
import { constants } from '../../../constants';

// UTILS
import { handleMaplePurchase } from 'utils/serviceUtils';
import ModulesContainer from '../../../components/ModuleList/ModulesContainer';
import mapValues from 'lodash/mapValues';
import { toArray } from 'utils/lodashUtils';
// interface ComponentProps extends React.Props<any> {
//     onChangeViewIndex?: any;
//     service?: any;
//     setBookingData?: any;

// }

class ServiceDetailView extends React.Component /*<ComponentProps, {}>*/ {
	constructor(props) {
		super(props);
		this.state = {
			showConfirmGetMaple: false,
			loginDialogOpen: false
		};
	}
	// componentWillMount() {
	//     this.props.getServiceModules(this.props.service._id);
	// }

	handleCloseLoginDialog = () => {
		this.props.setLoginDialogClosed();
	};

	handleShowLogin = () => {
		// console.log('set dialog to open');
		this.props.openLoginDialog();
	};

	getPriceAfterCredits = () => {
		const { credits } = this.props;
		const clientUser = this.props.user;
		const service = this.props.service;
		let price = service.price;
		if (clientUser && this.props.credits > 0) {
			if (this.props.credits >= price) {
				price = 0;
				return price;
			} else if (this.props.credits < price) {
				price = price - this.props.credits;
				return price;
			}
			return price;
		} else {
			price = service.price;
			return price;
		}
		// return price;
	};

	handleShowConfirmGetMaple = () => {
		// console.log('GET MAPLE CLICKED');

		this.setState({
			showConfirmGetMaple: true
		});
	};

	handleCloseConfirmGetMaple = () => {
		this.setState({
			showConfirmGetMaple: false
		});
	};

	handleConfirmGetMaple = (tax) => {
		handleMaplePurchase(tax, this.props.userData.uid, this.props.service._id);
		window.location = 'https://app.getmaple.ca/register/p/cyno2018pilot';
		// this.props.updateLocation(`https://www.getmaple.ca`);
	};

	render() {
		const { service, credits, user } = this.props;
		// const moduleDescriptionArray = this.getModuleDescriptions();
		const { bottomRightMargins } = styles;
		const priceAfterCredits = this.getPriceAfterCredits();
		// console.log(this.props.user, 'this is the user/clients')
		// console.log('serviceModuleDescriptions',this.props.serviceModuleDescriptions)
		// console.log('serviceModuleTypes', this.props.serviceModuleTypes)
		// console.log('service', this.props.service.duration)
		const isMaple = this.props.service.provider === 'x3J9MEouFCdsQCpu2PNhHRV9DBx1';

		// console.log('MODULES IN REDNER', this.props.serviceModules);

		return (
			<div ref="service" id="service">
				<ConfirmGetMaple
					modal={false}
					open={this.state.showConfirmGetMaple}
					handleClose={this.handleCloseConfirmGetMaple}
					onConfirmGetMaple={this.handleConfirmGetMaple}
				/>

				<FluidSection style={{ paddingBottom: 0 }}>
					<div>
						<Content
							mainTitleText={this.props.service.name}
							subTitleText={`with ${this.props.provider &&
								this.props.provider.name &&
								this.props.provider.name.first} ${this.props.provider &&
								this.props.provider.name &&
								this.props.provider.name.last} `}
						/>
					</div>
				</FluidSection>

				<FluidSection style={{ paddingTop: 0 }}>
					<div>
						{/* ONLY SHOW IF THIS IS NOT MAPLE OR IF THE SERVICE IS MAPLE AND THE USER HAS GREATER THAN 57.5 DOLLARS IN CREDITS */}
						{/* TODO: TEMPORARILY COMMENT OUT WHILE WE ARE WORKING ON MARKETPLACE CHANGES */}
						{(!isMaple || (isMaple && this.props.credits >= 5750)) && (
							<div>
								<div
									style={{
										display:
											this.props.user && this.props.credits && this.props.credits > 0
												? 'block'
												: 'none'
									}}
								>
									<Content
										style={{ marginTop: 20, marginBottom: -20 }}
										bodyText={'Price after credits'}
										bodyTextColor="#c70019d6"
									/>
								</div>

								<Content
									style={{ marginTop: 20, marginBottom: -10 }}
									subTitleText={`$${(this.getPriceAfterCredits() / 100).toFixed(2)} ${this.props
										.provider &&
									!this.props.provider.isTaxExempt &&
									this.getPriceAfterCredits() !== 0
										? '(+ tax)'
										: ''}`}
								/>

								<div
									style={{
										display:
											this.props.user && this.props.credits && this.props.credits > 0
												? 'block'
												: 'none'
									}}
								>
									<Content
										bodyTextColor="#999999"
										bodyTextSize={14}
										bodyText={`Regular $${this.props.service.price / 100} ${this.props.provider &&
										!this.props.provider.isTaxExempt
											? '(+ tax)'
											: ''}`}
									/>
								</div>
							</div>
						)}

						{/* ONLY SHOW IF NOT MAPLE */}
						{/* TODO: TEMPORARILY COMMENT OUT WHILE WE ARE WORKING ON MARKETPLACE CHANGES */}
						{!isMaple &&
						!process.env.REACT_APP_ENV === 'production' && (
							<div>
								<Button
									onClick={() => this.props.onChangeViewIndex(1)}
									alignButton={'flex-start'}
									style={{ marginBottom: 30, marginTop: 15 }}
									backgroundColor={constants.color.secondary}

									// style={ bottomRightMargins }
								>
									View Availability
								</Button>
							</div>
						)}

						{/* MUST HAVE ENOUGH CREDITS TO BE ABLE TO ACCESS MAPLE SERVICES... */}
						{/* NOTE: TEMPORARILY COMMENTED OUT WHILE WE ARE WORKING ON MARKETPLACE CHANGES */}
						{/* { isMaple && this.props.userData && this.props.credits > 5749.99 &&
                            <div>
                                <Button // OPENS A MODAL WINDOW EXPLAINING THAT THIS WILL DEDUCT YOUR CYNO CREDITS - YOU WILL BE REDIRECTED TO MAPLE'S WEBSITE + tax AGREE DONT AGREE
                                    // onClick={() => this.handleShowConfirmGetMaple()}
                                    alignButton={'flex-start'}
                                    style={{marginBottom: 30, marginTop: 10 }}
                                    backgroundColor='lightgray'
                                    // style={ bottomRightMargins }
                                >
                                    See an On-Demand Physician Now 
                                </Button>
                                <span style={{ marginTop: 40, color: 'darkred', fontWeight: 700, fontSize: 16 }}>New service purchasing is now closed. Thank you for your participation.</span>
                            </div>
                        } */}

						{/* IF NOT ENOUGH CREDITS OR LOGGED OUT SHOW INACTIVE BUTTON OR LOGIN PROMPT */}
						{/* NOTE: TEMPORARILY COMMENTED OUT WHILE WE ARE WORKING ON MARKETPLACE CHANGES */}
						{/* { isMaple && (this.props.credits < 5750 || !this.props.userData) &&
                            <div style={{ marginTop: 40 }}>
                                { !this.props.userData &&
                                    <Button
                                        onClick={() => this.handleShowLogin()}
                                        alignButton={'flex-start'}
                                        style={{marginBottom: 30, marginTop: 10,}}
                                        // style={ bottomRightMargins }
                                    >
                                        Login to get access
                                    </Button>
                                }
                                { this.props.userData &&
                                    <div>
                                        <Button
                                            // onClick={() => null }
                                            alignButton={'flex-start'}
                                            style={{marginBottom: 30, marginTop: 10, cursor: 'default'}}
                                            backgroundColor={'lightgray'}
                                            disabled={true}
                                            // style={ bottomRightMargins }
                                        >
                                            See an On-Demand Physician Now
                                        </Button>
                                        <span style={{ marginTop: 40, color: 'darkred', fontWeight: 700 }}>NOTE: At the moment, this offer is only available with payment via credits. You'll see this if you have insufficient credits for purchase or if you're not in our Corporate Employee Program. </span>
                                    </div>
                                }
                            </div>
                            } */}
					</div>
					{/* </div> */}
					{/* <Content
                            backgroundImageURL={this.props.service.coverPhotoURL}
                            style={ servicePhotoStyles }
                        /> */}
				</FluidSection>
				{/* <div style={ mainContainerStyles }> */}
				{/* </div> */}
				<FluidSection style={{ paddingTop: 0 }}>
					{this.props.serviceModules[service && service._id] &&
					this.props.serviceModules[service && service._id].length > 0 && (
						<ModulesContainer>
							<ModuleList
								// iconSize={10}
								serviceModules={[ ...this.props.serviceModules[this.props.service._id] ]}
								titleText="This Service Includes"
								description
								// style={ bottomRightMargins }
							/>
						</ModulesContainer>
					)}
					{this.props.service.description && (
						<Content
							style={bottomRightMargins}
							subTitleText={'Summary'}
							bodyText={this.props.service.description}
						/>
					)}
					{this.props.service.duration &&
					this.props.service.duration > 0 && (
						<Content
							style={bottomRightMargins}
							subTitleText={'Service Duration'}
							bodyText={`This service has a ${this.props.service
								.duration}-day duration starting the day of your video consultation.`}
						/>
					)}
					{isMaple && (
						<div>
							<List
								faIcon={'circle'}
								iconSize={10}
								style={{ marginBottom: 40 }}
								data={[
									'Abrasions',
									'Acne',
									'Allergies',
									'Asthma',
									'Bacterial Vaginosis',
									'Bites & Stings',
									'Body Aches',
									'Bronchitis',
									'Cough',
									'Dehydration',
									'Diarrhea',
									'Earache',
									'Erectile Dysfunction',
									'Fever',
									'Flu',
									'Frostbite',
									'Headaches & Migraines',
									'Hives',
									'Insomnia',
									'Lice',
									'Medication Refills',
									'Mild Lacerations',
									'Nasal Congestion',
									'Nausea',
									'Pinkeye',
									'Respiratory Infections',
									'Sexually Transmitted Infections',
									'Sick notes for work or school',
									'Sinus Infections',
									'Skin Infections',
									'Sore Throat',
									'Sprains & Strains',
									'Travel Medications',
									'Urinary Tract Infections',
									'Vomiting',
									'Yeast Infections',
									'...and many more'
								]}
								titleText="Maple Physicians can treat..."
							/>
						</div>
					)}
				</FluidSection>

				<FluidSection style={{ marginBottom: -25, paddingBottom: 0 }}>
					<Content
						subTitleText={`View ${this.props.provider &&
							this.props.provider.name &&
							this.props.provider.name.first}'s Profile`}
					/>
				</FluidSection>

				<FluidSection style={{ marginBottom: 0, paddingBottom: 0 }} sectionMinWidth={140} sectionMaxWidth={225}>
					<StretchCard
						key={this.props.provider && this.props.provider.uid}
						cardImageHeight={225}
						linkURL={`/expert/${this.props.provider && this.props.provider.uid}`}
						backgroundImageURL={this.props.provider && this.props.provider.profilePhotoURL}
						typeTitleText={this.props.provider && this.props.provider.expertise}
						mainTitleText={this.props.provider && this.props.provider.designation}
						// subTitleText={"Services starting at | "}
						// subTitlePrice={`$${this.props.service.price/100}`}
						cardTypeTitleColor={'#4AC4D1'}
						flexDirection={'column-reverse'}
						fontSizeDivider={1.3}
					/>
				</FluidSection>
			</div>
		);
	}
}

const styles = {
	bottomRightMargins: {
		marginBottom: 40,
		marginRight: 40
	}
};

const mapStateToProps = ({ payment, service, client, auth }) => {
	return {
		userData: client.clientData,
		credits: payment.credits,
		serviceModules: service.customModules,
		loginDialogOpen: auth.loginDialogOpen
	};
};

export default connect(mapStateToProps, actions)(ServiceDetailView);



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceSalesFlow/ServiceDetailView.jsx